module.exports = __webpack_public_path__ + "1c13783f2f87dd54b1c94691cdb42202.png";